import React from "react";

export const Contact = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={26}
      height={26}
      viewBox="0 0 26 26"
      fill="none"
      {...props}
    >
      <path
        d="M18.0037 0.733398V17.1278C18.0037 18.0769 17.2266 18.8535 16.2767 18.8535H2.46094C3.41077 18.8535 4.18791 18.0769 4.18791 17.1278V0.733398H18.0037Z"
        fill="white"
      />
      <path
        d="M18.7377 0.733433C18.7377 0.328751 18.4087 0 18.0038 0H4.18799C3.78301 0 3.45402 0.328751 3.45402 0.733433V17.1278C3.45402 17.6732 3.00674 18.1201 2.46101 18.1201C2.05604 18.1201 1.72705 18.4489 1.72705 18.8536C1.72705 19.2582 2.05604 19.587 2.46101 19.587H16.2768C17.6307 19.587 18.7377 18.4808 18.7377 17.1278V0.733433ZM4.71126 18.1201C4.84683 17.8164 4.92195 17.4807 4.92195 17.1278V1.46687H17.2698V17.1278C17.2698 17.6732 16.8225 18.1201 16.2768 18.1201H4.71126Z"
        fill="#4BCFFF"
      />
      <path
        d="M4.18783 4.18506V17.128C4.18783 18.0771 3.41069 18.8537 2.46086 18.8537C2.00321 18.8537 1.56283 18.6725 1.24334 18.3446C0.915219 18.0254 0.733887 17.5853 0.733887 17.128V4.18506H4.18783Z"
        fill="#D7F4F4"
      />
      <path
        d="M4.92187 4.18509C4.92187 3.78041 4.59288 3.45166 4.18791 3.45166H0.733963C0.328988 3.45166 0 3.78041 0 4.18509V17.128C0 17.7795 0.259046 18.4068 0.724465 18.8633C1.18125 19.3283 1.809 19.5872 2.46094 19.5872C3.81488 19.5872 4.92187 18.481 4.92187 17.128V4.18509ZM3.45395 4.91853V17.128C3.45395 17.6734 3.00666 18.1203 2.46094 18.1203C2.20103 18.1203 1.95062 18.0194 1.76928 17.833C1.76497 17.8287 1.75979 17.8235 1.75547 17.8192C1.56895 17.638 1.46793 17.3878 1.46793 17.128V4.91853H3.45395Z"
        fill="#4BCFFF"
      />
      <path
        d="M17.2143 12.9053C19.5975 12.9053 21.5317 14.8381 21.5317 17.2196C21.5317 19.6011 19.5975 21.5339 17.2143 21.5339C14.8311 21.5339 12.8969 19.6011 12.8969 17.2196C12.8969 14.8381 14.8311 12.9053 17.2143 12.9053Z"
        fill="white"
      />
      <path
        d="M17.2145 12.1719C14.4263 12.1719 12.1631 14.4334 12.1631 17.2196C12.1631 20.0058 14.4263 22.2674 17.2145 22.2674C20.0027 22.2674 22.2659 20.0058 22.2659 17.2196C22.2659 14.4334 20.0027 12.1719 17.2145 12.1719ZM17.2145 13.6387C19.1919 13.6387 20.7979 15.2437 20.7979 17.2196C20.7979 19.1956 19.1919 20.8005 17.2145 20.8005C15.2371 20.8005 13.631 19.1956 13.631 17.2196C13.631 15.2437 15.2371 13.6387 17.2145 13.6387Z"
        fill="#3377FF"
      />
      <path
        d="M22.3581 21.2045L21.2021 22.3604L23.8018 24.9566L24.9578 23.8007L22.3581 21.2045Z"
        fill="white"
      />
      <path
        d="M20.651 21.809C20.3801 22.08 20.407 22.5469 20.7123 22.852L23.3101 25.4482C23.6155 25.7534 24.0823 25.7799 24.3531 25.5089L25.5092 24.3521C25.78 24.0812 25.7532 23.6143 25.4479 23.3092L22.85 20.713C22.5447 20.4078 22.0778 20.3813 21.807 20.6523L20.651 21.809ZM22.2462 22.4216L22.4205 22.2471L23.914 23.7396L23.7396 23.9141L22.2462 22.4216Z"
        fill="#3377FF"
      />
      <path
        d="M19.7575 20.8647L21.264 22.3701C21.5349 22.6408 22.0026 22.6133 22.3074 22.3088C22.6122 22.0042 22.6397 21.5368 22.3688 21.2661L20.8622 19.7607C20.5913 19.49 20.1236 19.5175 19.8188 19.822C19.5141 20.1266 19.4866 20.5939 19.7575 20.8647Z"
        fill="#3377FF"
      />
      <path
        d="M15.8441 17.8614H18.4361C18.8418 17.8614 19.1697 17.5326 19.1697 17.128C19.1697 16.7233 18.8418 16.3945 18.4361 16.3945H15.8441C15.4385 16.3945 15.1106 16.7233 15.1106 17.128C15.1106 17.5326 15.4385 17.8614 15.8441 17.8614Z"
        fill="#4BCFFF"
      />
      <path
        d="M15.4136 4.18457H6.77871V6.77316H15.4136V4.18457Z"
        fill="white"
      />
      <path
        d="M6.77888 3.45117C6.3739 3.45117 6.04491 3.77992 6.04491 4.18461V6.77319C6.04491 7.17788 6.3739 7.50663 6.77888 7.50663H15.4137C15.8187 7.50663 16.1477 7.17788 16.1477 6.77319V4.18461C16.1477 3.77992 15.8187 3.45117 15.4137 3.45117H6.77888ZM7.51284 4.91804H14.6798V6.03976H7.51284V4.91804Z"
        fill="#3377FF"
      />
      <path
        d="M6.7784 10.0958H15.4133C15.8182 10.0958 16.1472 9.76702 16.1472 9.36234C16.1472 8.95766 15.8182 8.62891 15.4133 8.62891H6.7784C6.37342 8.62891 6.04443 8.95766 6.04443 9.36234C6.04443 9.76702 6.37342 10.0958 6.7784 10.0958Z"
        fill="#3377FF"
      />
      <path
        d="M6.7784 12.6842H11.9593C12.3643 12.6842 12.6933 12.3554 12.6933 11.9507C12.6933 11.546 12.3643 11.2173 11.9593 11.2173H6.7784C6.37342 11.2173 6.04443 11.546 6.04443 11.9507C6.04443 12.3554 6.37342 12.6842 6.7784 12.6842Z"
        fill="#3377FF"
      />
    </svg>
  );
};
